// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DBConstraint } from './DBConstraint';
import { DBTable } from './DBTable';
import { IndexColumn } from './IndexColumn';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 索引约束 实体类
 * 索引约束
 */
export class IndexConstraint extends DBConstraint {
  /** 是否聚集 : 是否是聚集索引，一个表只能由一个聚集索引 */
  private _isClustered: boolean;

  /** 设置：是否聚集 */
  public get isClustered() {
    return this._isClustered;
  }

  /** 获取：是否聚集 */
  public set isClustered(value: boolean) {
    this._isClustered = value;
  }

  /** 是否唯一 : 是否是唯一性约束 */
  private _isUnique: boolean;

  /** 设置：是否唯一 */
  public get isUnique() {
    return this._isUnique;
  }

  /** 获取：是否唯一 */
  public set isUnique(value: boolean) {
    this._isUnique = value;
  }

  /** 数据库表 的ID */
  private _table_ID: string;

  /** 获取：数据库表 的ID */
  public get table_ID() {
    return this._table_ID;
  }

  /** 设置：数据库表 的ID */
  public set table_ID(value: string) {
    this._table_ID = value;
  }

  /** 数据库表  */
  private _table: DBTable;

  /** 获取：数据库表  */
  public get table() {
    return this._table;
  }

  /** 设置：数据库表  */
  public set table(value: DBTable) {
    this._table = value;
    if (value !== null) {
      this.table_ID = value.id;
    } else {
      this.table_ID = '';
    }
  }

  /** 索引列 */
  private _indexColumns: Array<IndexColumn>;

  /** 获取：索引列 */
  public get indexColumns() {
    return this._indexColumns;
  }

  /** 设置：索引列 */
  public set indexColumns(value: Array<IndexColumn>) {
    this._indexColumns = value;
  }

  constructor() {
    super();
    this._isClustered = false;
    this._isUnique = false;
    this._table_ID = '';
    this._table = null;
    this._indexColumns = new Array<IndexColumn>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: IndexConstraint, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isClustered = element.isClustered;
      this.isUnique = element.isUnique;
      this.table_ID = element.table_ID;
      if (hasReference && element.table !== null) {
        this.table = element.table;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isClustered = json.IsClustered;
    this.isUnique = json.IsUnique;
    this.table_ID = json.Table_ID;
    // if (json.Table !== null) {
    //   this.table = DBTable.Create(json.Table);
    // }
    if (json.IndexColumns && json.IndexColumns.length > 0) {
      json.IndexColumns.forEach((element: any) => {
        const indexColumn = IndexColumn.Create(element);
        // indexColumn.indexConstraint = this;
        this.indexColumns.push(indexColumn);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsClustered = this.isClustered;
    json.IsUnique = this.isUnique;
    json.Table_ID = this.table_ID;
    if (this.indexColumns && this.indexColumns.length > 0) {
      json.IndexColumns = [];
      this.indexColumns.forEach((element) => {
        json.IndexColumns.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'isClustered', '是否聚集', EnumDataType.Bool, this.isClustered, true, '是否是聚集索引，一个表只能由一个聚集索引', '', '');
    context.addRow('基本属性', 'isUnique', '是否唯一', EnumDataType.Bool, this.isUnique, true, '是否是唯一性约束', '', '');
    return context;
  }

  static Create(json: any): IndexConstraint {
    const indexConstraint = new IndexConstraint();
    indexConstraint.Deserialize(json);
    indexConstraint.json = json;
    return indexConstraint;
  }
}
